module.exports = __webpack_public_path__ + "static/media/perito_p.1b02e688.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/perito_p.png
// module id = 1160
// module chunks = 0